import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Text } from '@newcore/ui/typography';
import type { ToastOptions } from '@/utils/toast';

interface ToastMessageProps {
  options: ToastOptions;
}

export function ToastMessage({ options }: ToastMessageProps) {
  if (typeof options === 'string') {
    return <>{options}</>;
  }

  if (options.title) {
    return (
      <div>
        <Text
          as='strong'
          weight={FontWeights.SEMIBOLD}
          data-testid='toast-title'
        >
          {options.title}
        </Text>
        <div data-testid='toast-message'>{options.message}</div>
      </div>
    );
  }

  return <>{options.message}</>;
}
